// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.dev.ts`.
// The list of file replacements can be found in `angular.json`.
const environment = {
  backend: {
    endpoint: '/api',
  },
  cognito: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_3z4aaMP27',
    userPoolWebClientId: '5bi7qkmod7mgrde67qrcii2nj3',
  },
};

export { environment };
